import showcase from '@app/lang/reverse/es/showcase';
import { COMMON_ES } from '@app/lang/reverse/es/common';
import { SEARCHING_ES } from '@app/lang/reverse/es/searching';
import { INTERVIEWING_ES } from '@app/lang/reverse/es/interviewing';
import { CLOSING_ES } from '@app/lang/reverse/es/closing';
import { SUCCESS_FEE_ES } from '@app/lang/reverse/es/success-fee';
import { HOMEPAGE_ES } from '@app/lang/reverse/es/homepage';
import { CANDIDATE_DETAILS_ES } from '@app/lang/reverse/es/candidate-details';
import { ERRORS_ES } from '@app/lang/reverse/es/errors';
import * as PROFILING_ES from '@app/lang/reverse/es/profiling.json';
import * as LOGIN_ES from '@app/lang/reverse/es/login.json';
import * as GLOBAL_COMPENSATION_ES from '@app/lang/reverse/es/global-compensation.json';

const ES = {
  translation: {
    header: {
      welcome: 'Hola',
      share: 'Compartir',
      hide_compensation: 'Presentar con la compensación oculta',
      show_compensation: 'Mostrar la compensación',
    },
    hero: {
      backToHomepage: 'Todos tus servicios',
      backToHomepage_headHunter: 'Todos los servicios del cliente',
      prospect: {
        title: 'Cálculo de la tarifa a éxito',
      },
      steps: {
        profiling: {
          title: 'Perfil',
          title_no_miro: 'Personas de contacto',
          description: 'Inicio',
        },
        searching: {
          title: 'Búsqueda',
          description: '1-10°días',
        },
        showcase: {
          title: 'Showcase',
          description: '11°día',
        },
        interviewing: {
          title: 'Entrevistas',
          title_marketing: 'Talentos',
          description: '11-20°días',
        },
        closing: {
          title: 'Contratación',
          description: 'Fin',
        },
      },
      helper: {
        profiling: {
          'to-do':
            'Hola. Te presentamos nuestro proceso. Si lo desea, puede echar un vistazo. Siempre <strong>podrá ver</strong> el progreso.',
          'to-do_withName':
            'Hola {{ name }}. Te presentamos nuestro proceso. Si lo desea, puede echar un vistazo. Siempre <strong>podrá ver</strong> el progreso.',
          doing: '$t(hero.helper.profiling.to-do)',
          doing_withName: '$t(hero.helper.profiling.to-do_withName)',
          done: 'En esta página encontrarás un resumen siempre actualizado del perfil del candidato, de su empresa y de nuestro servicio.',
        },
        searching: {
          'to-do':
            'Durante la búsqueda, <strong>podrás ver las actividades que llevamos a cabo</strong>, hasta que los datos estén disponibles.',
          doing:
            'Durante la búsqueda, <strong>podrás ver las actividades que llevamos a cabo</strong>, hasta que los datos estén disponibles.',
          done: 'Hemos presentado tu empresa y el puesto a los candidatos. Esto es <strong>lo que nos dicen los números</strong>.',
        },
        showcase: {
          'to-do':
            'Durante la búsqueda, <strong>podrás ver las actividades que llevamos a cabo</strong>, hasta que los datos estén disponibles.',
          doing:
            'Durante la búsqueda, <strong>podrás ver las actividades que llevamos a cabo</strong>, hasta que los datos estén disponibles.',
          done: '¡Fin de la búsqueda! A continuación, encontrarás <strong>las cifras</strong> y el <strong>JRA</strong>, nuestro análisis final.',
        },
        interviewing: {
          'to-do':
            'En esta fase, te <strong>mostraremos los candidatos</strong> y te pediremos <strong>feedback</strong>',
          doing:
            'Recuerda que <strong>cuanto más ágiles seamos, mayor será la probabilidad</strong> de éxito.',
          done: 'Recuerda que <strong>cuanto más ágiles seamos, mayor será la probabilidad</strong> de éxito.',
        },
        closing: {
          'to-do':
            'Es la fase final: la más delicada. <strong>Negociación, renuncias e incorporaciones</strong>.',
          doing:
            'Es la fase final: la más delicada. <strong>Negociación, renuncias e incorporaciones</strong>.',
          done: 'Es la fase final: la más delicada. <strong>Negociación, renuncias e incorporaciones</strong>.',
        },
        marketing: {
          profiling: {
            'to-do':
              'Hola. En estas páginas puedes ver los <strong>talentos que hemos seleccionado para ti</strong> y, si decides conocerlos, <strong>todo sobre su estado en el proceso de selección</strong>.',
            'to-do_withName':
              'Hola {{ name }}. En estas páginas puedes ver los <strong>talentos que hemos seleccionado para ti</strong> y, si decides conocerlos, <strong>todo sobre su estado en el proceso de selección</strong>.',
            doing: '$t(hero.helper.marketing.profiling.to-do)',
            doing_withName:
              '$t(hero.helper.marketing.profiling.to-do_withName)',
            done: '$t(hero.helper.profiling.done)',
          },
          interviewing: {
            'to-do':
              'Tan pronto como se identifiquen talentos que puedan ser <strong>adecuados para ti</strong>, los encontrarás aquí.',
            doing:
              'Los candidatos interesantes no permanecen disponibles por mucho tiempo. <strong>No pierdas la oportunidad de conocerlos</strong>.',
            done: '$t(hero.helper.marketing.interviewing.doing)',
          },
        },
      },
    },
    profile: {
      contract: {
        title: 'Aquí encontrarás el contrato de este mandato',
        title_marketing:
          'Descubre a los mejores talentos,<br/>paga solo cuando contrates.',
        download: 'Descargar el contrato',
      },
      references: {
        title: 'Tus personas de contacto',
        blank: {
          title: 'Estamos buscando a la persona adecuada para este trabajo',
          text: 'Queremos al mejor cazador que tenemos disponible...',
        },
      },
      mirror: {
        body: '<strong>Una nueva forma de seleccionar personal</strong><br><br>FLEXIBLE, DIGITAL, ESPECIALIZADA.',
        link: 'Descubre la selección de personal colaborativa',
      },
    },
    general: {
      error: {
        title: 'Se ha producido un error',
        subtitle:
          'Intenta actualizar la página. Si no consigues solucionar el problema, inténtalo de nuevo más tarde.',
        hash: {
          title: 'Este enlace ha caducado.',
          subtitle:
            'Deberías haber recibido el <strong>enlace correcto</strong> en uno de nuestros <strong>últimos correos electrónicos</strong>',
          disclaimer:
            '¿No lo encuentras? <strong>Comunícate con tus personas de contacto</strong>',
        },
        unauthorized: {
          title: 'Este enlace parece incorrecto.',
          subtitle:
            'Deberías haber recibido el <strong>enlace correcto</strong> en uno de nuestros <strong>correos electrónicos</strong>, <strong>poco después</strong> de la <strong>firma del contrato</strong>.',
          disclaimer:
            '¿No lo encuentras? <strong>Comunícate con tus personas de contacto</strong>',
        },
        unauthorizedHomepage: {
          title: 'No estás autorizado para ver esta página.',
          subtitle: '',
          disclaimer: '',
        },
      },
      document_title: {
        profiling: 'Perfil',
        searching: 'Búsqueda',
        interviewing: 'Entrevistas',
        closing: 'Cierre',
        showcase: 'Showcase',
      },
      document_title_reverse_marketing: {
        profiling: '$t(hero.steps.profiling.title_no_miro)',
        searching: '$t(hero.steps.searching.title)',
        interviewing: '$t(hero.steps.interviewing.title_marketing)',
        closing: '$t(hero.steps.closing.title)',
        showcase: '$t(hero.steps.showcase.title)',
      },
      date_on: 'los',
      date_hour: 'a las',
    },
    candidate: {
      hero: {
        title: 'estás buscando:',
        back_label: 'Atrás',
      },
      infos: {
        age: 'años',
        benefits: 'Beneficios actuales',
        bonuses: 'Bonificaciones actuales',
      },
      sections: {
        horse: {
          title: 'Estado actual',
        },
        bet: {
          open_chat: 'Escribir por chat a <strong>{{ name }}</strong>',
        },
        curriculum: {
          title: 'Curriculum Vitae',
          screening: 'Ranking de preselección',
          button: 'Abrir el currículum',
        },
        summary: {
          otherSelectionsTitle: 'Otros procesos de selección',
        },
        concerns: {
          intro:
            '{{ name }} es un perfil muy interesante pero no del todo acorde con los requisitos.',
        },
      },
    },
    footer: {
      company: 'Reverse España S.L.',
      headquarter: 'VAT B72409337',
      informations: [
        'Oficina reg.: Barcelona (08006)',
        'Carrer de Tuset, 10 Esc. Izq., 5º 2ª',
      ],
      menu: {
        contact: {
          label: 'Contáctenos',
          slug: 'contactenos',
        },
        legal: {
          label: 'Cookies',
          slug: 'legal',
        },
        cookies: {
          label: 'Legal&privacy',
          url: 'https://www.iubenda.com/privacy-policy/41212079/cookie-policy',
        },
      },
    },
    modal: {
      share: {
        title: 'Compartir el progreso de la selección con otros',
        inputs: {
          first_name: {
            label: 'Nombre',
            placeholder: 'Nombre',
          },
          last_name: {
            label: 'Apellido',
            placeholder: 'Apellido',
          },
          email: {
            label: 'Correo electrónico',
            placeholder: 'Correo electrónico',
            hint: 'El correo electrónico no coincide con el dominio con el que está registrado, ¿está seguro de que desea continuar?',
          },
          lang: {
            label: 'Lengua',
            placeholder: 'Seleccionar lengua',
          },
        },
        isCompensationPackageVisible: {
          label:
            'Permitir a la persona invitada <strong>ver los paquetes de compensación</strong> de los candidatos.',
        },
        lang_options: {
          it: 'Italiano',
          en: 'Inglés',
          de: 'Alemán',
          fr: 'Francés',
          es: 'Español',
        },
        button: 'Invitar',
        shared_with: 'Compartido con',
        alert: {
          positive: 'La invitación por correo electrónico ha sido enviada',
          negative:
            'Algo no ha ido bien. Inténtalo más tarde o comunícate con las personas de contacto',
          guest_info:
            'La persona invitada no podrá ver los paquetes de compensación de los candidatos. Si necesita acceder a esta información, pida a {{ mainClient }} o al headhunter que habiliten los permisos.',
        },
        table: {
          header: {
            name: 'Nombre',
            email: 'Correo electrónico',
            compensationVisibility: 'Visibilidad de la compensación',
          },
          guest: '(Invitado)',
          mainClient: '(Cliente principal)',
        },
      },
    },
    validation: {
      scout_approved: 'Validado por el Scout',
      scout_required: 'Validar con el Scout',
      required: 'Este campo es obligatorio',
      email: 'Esta dirección de correo electrónico no es válida',
    },
    language_switcher: {
      it: 'IT',
      en: 'EN',
      de: 'DE',
      fr: 'FR',
      es: 'ES',
    },
    showcase,
    candidateDetails: CANDIDATE_DETAILS_ES,
    common: COMMON_ES,
    searching: SEARCHING_ES,
    interviewing: INTERVIEWING_ES,
    closing: CLOSING_ES,
    successFee: SUCCESS_FEE_ES,
    globalCompensation: GLOBAL_COMPENSATION_ES,
    homepage: HOMEPAGE_ES,
    login: LOGIN_ES,
    profiling: PROFILING_ES,
    errors: ERRORS_ES,
  },
};

export default ES;
